export default __webpack_public_path__ + "static/media/logo.682ab44e.png";